import React from "react";
import AdminstrativeOrders from "./AdminstrativeActs";
import NotificationTCP from "./NotificationTCPAct";

export default function RTI() {
    return(
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
            <AdminstrativeOrders />
            <NotificationTCP />
        </div>
    )
}